import src from "IMAGE";
export default { src, width: 438, height: 81, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mNwc3OzcXd3t3F0dLSOiooKCgkJ8Q4NDfUJDg72BNEAmD8JnQFF200AAAAASUVORK5CYII="};
